export enum AchievementType {
  TRAIL_COMPLETE = 'trail-complete',
  QUIZ_COMPLETE = 'quiz-complete',

  UNKNOWN = 'unknown',
}